import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import { SendEvent } from '../../tracking/types';

export interface TrackingContext {
  /** Get the current user's anonymousId. Will populate from 1PT if possible */
  getAnonymousId: () => string | undefined;
  /** Send an event to the tracking system */
  sendEvent: SendEvent;
}

/**
 * Default context for sending events.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const TrackingContext = createContext<TrackingContext>({
  getAnonymousId: () => undefined,
  sendEvent: (_event, _destination) => {
    /* No-op */
  }
});

/**
 * Hook in order to access the tracking context. The context provider is responsible for defining
 *   the `sendEvent` function and must be a parent of the component using this hook. It can also
 *   serve up 1PT pixel information.
 * This hook will allow you to use the `sendEvent` function.
 */
export const useTrackingContext = () => useContext(TrackingContext);
